import React from "react";
import styles from "./TimeRangeStatus.module.scss";
import { formatDateUTCToTimeLocal } from "@src/module/utils/datetime";
import { useTimeRangeStatus } from "@pages/Dashboard/hooks/useTimeRangeStatus";

export interface TimeRangeStatusProps {
  startDate: string;
  endDate: string;
  isStartLate?: boolean;
  isEndLate?: boolean;
}

export const TimeRangeStatus: React.FC<TimeRangeStatusProps> = ({
  startDate,
  endDate,
  isStartLate = false,
  isEndLate = false,
}) => {
  const hasStart = Boolean(startDate);
  const hasEnd = Boolean(endDate);

  const { wrapperClass, startClass, endClass } = useTimeRangeStatus(
    {
      hasStart,
      hasEnd,
      isStartLate,
      isEndLate,
    },
    styles
  );

  const start = formatDateUTCToTimeLocal(startDate, "--:--");
  const end = formatDateUTCToTimeLocal(endDate, "--:--");

  return (
    <div className={`${styles.wrapper} ${wrapperClass}`.trim()}>
      <span className={startClass}>{start}</span>
      <span>-</span>
      <span className={endClass}>{end}</span>
    </div>
  );
};

export default TimeRangeStatus;
